import React, { useEffect, useState } from "react";
import request from "../../../Helpers/API";
import Swal from "sweetalert2";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import WarningIcon from "@mui/icons-material/Warning";
import PendingIcon from "@mui/icons-material/Pending";
import ErrorIcon from "@mui/icons-material/Error";
import { InputAdornment, TextField } from "@mui/material";
import { ValSpecialCharacters } from "../../../Validators/ValSpecialCharacters";
import CancelScheduleSendIcon from "@mui/icons-material/CancelScheduleSend";
import { ValFormReg } from "../../../Validators/ValForms";
import { RegularExpressions } from "../../../Helpers/RegularExpression";


export const AutorizarFacturacion = ({
  folio,
  setLoader,
  loader,
  updateComentarios,
  // Inyectado por ModalSolicitudCredito/ModalSolicitudCreditoJDF (ver ModalSCScreens).
  // Habilita "Siguiente" sin recargar data/estado del padre ni cerrar el modal.
  habilitarSiguiente,
  idproceso = 35,
  responsable = "G",
}) => {
  const [comentarios, setComentarios] = useState("");
  const [estatus, setEstatus] = useState({});
  const onChange = (prop, value, sbool, smensaje) => {
    setComentarios(value);
  };




  useEffect(() => {
    setLoader({ ...loader, mostrar: true });
    const post = {
      folio,
      idproceso: idproceso,
      responsable: responsable,
    };
    request
      .post(`ACAnalisisDecicion`, post)
      .then((result) => {
        setLoader({ ...loader, mostrar: false });
        setEstatus(result);
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire(
          "ANALISIS DE SOLICITUD DE CREDITO",
          JSON.stringify(error),
          "error"
        );
      });
  }, []);
  const onEnviarComentario = (accion) => {
    const rescomentarios = ValFormReg(
      "Comentarios",
      comentarios,
      RegularExpressions.TextSpecialCharacter,
      15,
      2000
    );
    if (rescomentarios.isValid === false) {
      Swal.fire(
        "ANALISIS DE SOLICITUD DE CREDITO",
        rescomentarios.mensaje,
        "error"
      );
      return;
    }
    setLoader({ ...loader, mostrar: true });
    const post = {
      folio,
      idproceso: idproceso,
      consecutivo: -1,
      comentarios,
      estatus: accion,
    };
    request
      .post("ACTimeLineComentarios/GuardarComentario", post)
      .then((result) => {
        setLoader({ ...loader, mostrar: false });
        setEstatus(result.estado);
        setComentarios("");

        if (updateComentarios !== undefined && updateComentarios !== null)
          updateComentarios();

        // Habilita "Siguiente" sin recargar data/estado ni cerrar el modal.
        if (habilitarSiguiente !== undefined && habilitarSiguiente !== null)
          habilitarSiguiente();
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire(
          "ANALISIS DE SOLICITUD DE CREDITO",
          JSON.stringify(error),
          "error"
        );
      });
  };

  const OnGetIcon = ({ icon }) => {
    switch (icon) {
      case "wait":
        return <PendingIcon />;
      case "success":
        return <CheckCircleIcon />;
      case "warning":
        return <WarningIcon />;
      case "error":
        return <ErrorIcon />;
      default:
        <></>;
    }
  };
  return (
    <div className="analisis-credito-modal-mhusa">
      <div className="analisis-credito-modal-mhusa-content">
        <div className="analisis-credito-modal-mhusa-content-buttons">
          {estatus.habilitar === undefined ||
            estatus.habilitar === null ||
            estatus.habilitar === false ? (
            <div
              className={`analisis-credito-modal-mhusa-content-comentarios analisis-credito-modal-mhusa-content-comentarios-${estatus.icono}`}
            >
              <div className="analisis-credito-modal-mhusa-content-comentarios-svg">
                <OnGetIcon icon={estatus.icono} />
              </div>
              <div className="analisis-credito-modal-mhusa-content-comentarios-div">
                {estatus.comentarios}
              </div>
            </div>
          ) : (
            <div className="analisis-credito-modal-mhusa-content-buttons-container">
              <TextField
                fullWidth
                size="small"
                label="Comentarios"
                className="cel-1"
                multiline
                rows={4}
                type="text"
                // error={condiciones.bcondiciones}
                onChange={({ target }) => {
                  ValSpecialCharacters(
                    "condiciones",
                    target.value,
                    onChange,
                    true,
                    500
                  );
                }}
                value={comentarios}
              />
              <dvi className="analisis-credito-modal-mhusa-content-buttons-container-buttons">
                <div
                  className="analisis-credito-modal-mhusa-content-acept-button"
                  onClick={() => {
                    onEnviarComentario("A");
                  }}
                >
                  <CheckCircleIcon />
                  <div>Autorizar Facturación</div>
                </div>

                {/* <div
                  className="analisis-credito-modal-mhusa-content-cancel-button"
                  onClick={() => {
                    onEnviarComentario('M')
                  }}
                >
                  <CancelIcon />
                  <div>RECHAZAR</div>
                </div> */}
              </dvi>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
